const TargetIcon = ({ size = 24, color = 'currentColor', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle
                cx="11.7929"
                cy="12.207"
                r="3.07829"
                transform="rotate(-45 11.7929 12.207)"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.1853 9.92866C19.6953 11.5836 19.6353 13.3617 19.0149 14.9785C18.3944 16.5952 17.2494 17.957 15.7632 18.8458C14.277 19.7346 12.5355 20.099 10.8176 19.8806C9.0997 19.6622 7.50477 18.8737 6.28818 17.6414C5.0716 16.409 4.30373 14.804 4.10752 13.0835C3.91132 11.3629 4.29813 9.62626 5.20601 8.15161C6.1139 6.67697 7.49035 5.54962 9.11497 4.95008C10.7396 4.35053 12.5184 4.31347 14.1666 4.84483"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.8604 12.1606L16.1887 7.8325M16.1887 7.8325L16.1887 5.71118L18.31 3.58986V5.71118H20.4314L18.31 7.8325L16.1887 7.8325Z"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default TargetIcon
